import clsx from 'clsx';
import {FC, ReactNode} from 'react';

import {LayoutProvider} from '../context';

export type SideBySideProps = {
    children: ReactNode;
    className?: string;
    spacing?: 'sm';
};

const SideBySide: FC<SideBySideProps> = ({children, className, spacing}) => (
    <LayoutProvider type="sideBySide">
        <div
            className={clsx(
                'side-by-side',
                spacing === 'sm' && 'sm',
                className,
            )}
        >
            {children}
        </div>
    </LayoutProvider>
);

export default SideBySide;
